<template>
  <div class="block">
    <h2>{{ $t('additionalSettings') }}</h2>

    <div v-for="(item, index) in addOpt" :key="index" class="unit">
      <custom-field :input="{...item, index: `addOpt-${index}`, addOpt: true}" v-model.trim="addOptions[item.id]"/>
    </div>
  </div>
</template>

<script>
  import { CART_MUTATIONS } from "@/store/modules/cart-context";
  import CustomField from '@/shared/components/CustomFields/CustomField.vue';

  export default {
    name: "AdditionalOptions",
    components: {
      CustomField,
    },
    props: {
      addOpt: { type: [Object, Array] },
    },
    data: () => ({
      addOptions: {},
    }),
    watch: {
      addOptions: {
        handler() {
          this.$store.commit(`cartContext/${CART_MUTATIONS.SET_CART_CONTEXT}`, { productCustomfields: this.addOptions });
        },
        deep: true,
      }
    },
  }
</script>
